import React,{useContext,useEffect, useState, useRef,useReducer} from 'react';
import { LocaleContext } from '../../../components/LocaleContext';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, LoadPrioIcon} from "../../svg/svgIcons";
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from '../../../components/PrimeCalendar';
import { addLocale } from 'primereact/api';
import { Chips } from 'primereact/chips';
import { Message } from 'primereact/message';

const EMPTY_CHECKLIST_SUMMARY_FORM = {
    type: 'checklists',
    name: '',
    email_time: '',
    regularity: '',
    interval: '',
    status: '',
    time_period: [],
    other_emails: [],
    departments: [],
    checklists: [],
    statuses: [],
    hours_before: '',
    nok_deadline: '',
    recipient_departments: [],
    recipients: [],
};

function parseSummaryData(rawData) {
    if (!rawData) return {};
    if (typeof rawData === 'object') return rawData;
    if (typeof rawData !== 'string') return {};
    try {
        return JSON.parse(rawData);
    } catch (_e) {
        return {};
    }
}

function summaryEmailToFormValues(record) {
    if (!record) {
        return { ...EMPTY_CHECKLIST_SUMMARY_FORM };
    }
    const parsed = parseSummaryData(record?.data);
    return {
        id: record.id,
        type: record.type || 'checklists',
        name: record.name || '',
        email_time: record.email_time || '',
        regularity: record.regularity || '',
        interval: record.interval || '',
        status: record.status || '',
        time_period: parsed?.time_period?.map((time_period) => ({ name: time_period.name })) || [],
        other_emails: record.other_emails ? String(record.other_emails).split(',').map((e) => e.trim()).filter(Boolean) : [],
        departments: parsed?.departments || [],
        checklists: parsed?.checklists || [],
        statuses: parsed?.statuses || [],
        recipient_departments: parsed?.recipient_departments || [],
        recipients: parsed?.recipients || [],
    };
}

export default function SummaryEmailChecklistAdd({summary_email, type="add"}) {
  const { t } = useContext(LocaleContext);
    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {openFavoriteDialog,toast,setFastView,setDialogText,setVisible}= useContext(UtilContext);

    addLocale('sk', {
        firstDayOfWeek: 1,
        showMonthAfterYear: false,
        dayNames: ['Nedela','Pondelok', 'Utorok', 'Streda', t('Common.Day.Thursday'), 'Piatok', 'Sobota'],
        dayNamesShort: ['Ne','Pon','Ut','Str','Štv','Pia','So'],
        dayNamesMin: ['Ne','Po', 'Ut', 'Str', 'Štv', 'Pi', 'So'],
        monthNames: [t('Common.Month.January'), t('Common.Month.February'), 'Marec', t('Common.Month.April'), 'Máj ', t('Common.Month.June'), t('Common.Month.July'), 'August', 'September', t('Common.Month.October'), 'November', 'December'],
        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj ', t('Common.Month.June'), t('Common.Month.July'), 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
        today: 'Dnes',
        clear: t('Common.Delete')
    });

    const [closeTab,setCloseTab] = useState(false);
    const [throwInvalidEmail,setThrowInvalidEmail] = useState(false);
    const submitRef = useRef(null);

    const [formSummaryEmail,setFormSummaryEmail] = useState(summary_email);
    const [formType, setFormType] = useState(type);
    const summaryData = parseSummaryData(summary_email?.data);
    const [types,setTypes] = useState(type == "edit" ? summaryData : []);

    const [checklists, setChecklists] = useState(state.checklist_templates);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState(!user.permissions?.includes("edit checklists-setup"));


    function addNewSummaryEmail(){
      dispatch({type:'create_new_tab',name: t('Common.SummaryEmail'), translationKey: 'Common.SummaryEmail', legacyLabel: t('Common.SummaryEmail'),page:'SummaryEmailChecklistAdd',props:{summary_email: null,type:'add'},mask:'chck008'})
    }
    function copySummaryEmail(){
      dispatch({type:'create_new_tab',name: t('Common.SummaryEmail'), translationKey: 'Common.SummaryEmail', legacyLabel: t('Common.SummaryEmail'),page:'SummaryEmailChecklistAdd',props:{summary_email: summary_email,type:'add'},mask:'chck008'})
    }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
      initialValues: formSummaryEmail == null
        ? { ...EMPTY_CHECKLIST_SUMMARY_FORM }
        : summaryEmailToFormValues(formSummaryEmail),

      enableReinitialize: true,
      validate,

      onSubmit: values => {
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();

        formData.append("name", values.name);
        formData.append("type", values.type);
        formData.append("regularity", values.regularity);
        formData.append("interval", values.interval);
        formData.append("status", values.status);
        formData.append("email_time", values.email_time);
        formData.append("other_emails", values.other_emails != null ? values.other_emails : "");

        const data = {
          departments: values.departments,
          time_period: values.time_period,
          checklists: values.checklists,
          statuses: values.statuses,
          recipient_departments: values.recipient_departments,
          recipients: values.recipients,
        };
        formData.append("data", JSON.stringify(data));

        if (formType === "add") {
          postRequest('/api/summary_emails', formData, true)
            .then((saveRes) => {
              if (saveRes?.status !== 201 && !saveRes?.data?.id) {
                setVisible(false);
                alert(t('Common.Toast.ActionFailedDetail'));
                return;
              }
              getRequest("/api/summary_emails").then((listRes) => {
                if (listRes?.data) {
                  dispatch({ type: 'load_summary_emails', newSummaryEmails: listRes.data });
                }
                if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                const saved = saveRes?.data;
                if (saved?.id) {
                  setFormSummaryEmail(saved);
                  formik.setValues({
                    ...summaryEmailToFormValues(saved),
                    other_emails: saved.other_emails
                      ? String(saved.other_emails).split(',').map((e) => e.trim()).filter(Boolean)
                      : (Array.isArray(values.other_emails) ? values.other_emails : []),
                  });
                }
                setFormType("edit");
                setVisible(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
              });
            }).catch(() => {
              setVisible(false);
              alert(t('Common.Toast.ActionFailedDetail'));
            });
        } else {
          postRequest(`/api/summary_emails/update/${formik.values.id}`, formData, true)
            .then((saveRes) => {
              if (saveRes?.status !== 200) {
                setVisible(false);
                alert(t('Common.Toast.ActionFailedDetail'));
                return;
              }
              getRequest("/api/summary_emails").then((listRes) => {
                if (listRes?.data) {
                  dispatch({ type: 'load_summary_emails', newSummaryEmails: listRes.data });
                }
                if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                formik.setValues(values);
                setVisible(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
              });
            }).catch(() => {
              setVisible(false);
              alert(t('Common.Toast.ActionFailedDetail'));
            });
        }
      },
    });


    const weekTimePeriod = [
        {name: 'Pondelok'},
        {name: 'Utorok'},
        {name: 'Streda'},
        {name: t('Common.Day.Thursday')},
        {name: 'Piatok'},
        {name: 'Sobota'},
        {name: 'Nedeľa'},
    ];

    const monthTimePeriod = Array.from({length: 31}, (_, i) => i + 1).map((i) =>{
        return {name: ''+i};}   
    )

    function emailValidation(email){
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if ( re.test(email) ) {
          setThrowInvalidEmail(false);
          return true;
      }
      else {
          setThrowInvalidEmail(true);
          return false;
      }
    }

    const handleDepartmentChange = (e) => {
      const selectedDepartments = e.value || [];

      // Nastavíme vybrané oddelenia do Formiku
      formik.setFieldValue("departments", selectedDepartments);

      // Ak nie je vybrané žiadne oddelenie, zobrazíme všetky checklist_templates
      if (selectedDepartments.length === 0) {
        setChecklists(state.checklist_templates || []);
        return;
      }

      const selectedDepartmentIds = selectedDepartments.map((dept) => dept.id);

      // Vyfiltrujeme checklisty podľa priradených userov z vybraných oddelení
      const filteredChecklists = state.checklist_templates.filter((template) =>
        template.users.some(
          (user) =>
            user.employee &&
            selectedDepartmentIds.includes(user.employee.department_id)
        )
      );

      setChecklists(filteredChecklists);
    };


    return (
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
      <IntersectionObserverWrapper>
      <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="saveandclose"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="save"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => submitRef.current.click()}><SaveIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewSummaryEmail()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copySummaryEmail()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button onClick={() => openFavoriteDialog(t('Common.NewSummaryEmail'),"SummaryEmailCalibrationAdd")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("SummaryEmailCalibrationAdd",null,null)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        </IntersectionObserverWrapper>
      </div>
      <div className='overflow-y-auto h-[calc(100vh-177px)]'>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col justify-left overflow-x">
        <div className="xl:grid grid-cols-2 gap-4 mb-4">
          <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
            <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('SummaryEmailOTKAdd.Heading')}</h1>
            {formType === "edit" && (
              <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>
            )}

            {/* Nazov Emailu */}
            <label className="block text-md font-semibold text-gray-800">{t('Common.Name')}</label>
            <input
              name="name"
              type="text"
              required
              onChange={formik.handleChange}
              value={formik.values.name}
              className="block w-full px-4 py-2 mt-2 mb-4 text-grey-700 bg-white border rounded-md"
            />

            {/* Oddelenie checklistu */}
            <label className="block text-md font-semibold text-gray-800">Oddelenie checklistu</label>
            <MultiSelect
              value={formik.values.departments}
              onChange={handleDepartmentChange}
              options={state.departments || []}
              optionLabel="name"
              placeholder={t('Common.SelectDepartments')}
              className="w-full mt-2 mb-4"
            />

            {/* Nazov checklistu */}
            <label className="block text-md font-semibold text-gray-800">Checklist</label>
            <MultiSelect
              value={formik.values.checklists}
              onChange={(e) => formik.setFieldValue("checklists", e.value)}
              options={checklists || []}
              optionLabel="name"
              placeholder={t('Checklist.SelectChecklists')}
              className="w-full mt-2 mb-4"
            />
            <div>
              <label
                  htmlFor="status"
                  className="block text-md font-semibold text-gray-800"
              >
                  Typ
              </label>
              <select 
              name='status'
              required
              onChange={formik.handleChange} value={formik.values.status}
              className={`bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                <option value="">{t('Common.SelectOption')}</option>
                <option value="Všetky">{t('Common.All')}</option>
                <option value="Otvorený">{t('CrmCommunication.OverallStatus.open')}</option>
                <option value="Uzavretý">{t('ServiceTask.Status.Closed')}</option>
              </select>
            </div>

            <div>
              <label
                  htmlFor="interval"
                  className="block text-md font-semibold text-gray-800"
              >
                  Interval
              </label>
              <select 
              name='interval' required
              onChange={formik.handleChange} value={formik.values.interval}
              className={`bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                  <option value="">{t('Common.SelectOption')}</option>
                  <option value="Všetky">{t('Common.FilterAll')}</option>
                  <option value="Predch. deň">{t('Common.PrevDay')}</option>
                  <option value="Predch. týždeň">{t('Common.PrevWeek')}</option>
                  <option value="Predch. mesiac">Predch. mesiac</option>
                  <option value="Vlastný">{t('Ui.R67.Vlastny')}</option>
              </select>
            </div>
            {formik.values.interval=="Vlastný" && <div>
                <label
                    htmlFor="dates"
                    className="block text-md font-semibold text-gray-800"
                >
                    OD - DO:
                </label>
                <Calendar required id="buttondisplay" name="dates" style={{border: '1px solid #e5e7eb',transition: 'background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s',borderRadius: '6px'}} 
                value={formik.values.dates} onChange={(e) => formik.setFieldValue("dates",e.target.value)} showIcon className="w-full"locale="sk" dateFormat="dd.mm.yy" selectionMode="range" hideOnRangeSelection />
            </div>
            }

            {/* Dôvody odoslania */}
            <label className="block text-md font-semibold text-gray-800">{t('Common.States')}</label>
            <MultiSelect
              value={formik.values.statuses}
              onChange={(e) => formik.setFieldValue("statuses", e.value)}
              options={[
                { name: "Nevykonanie CheckListu" },
                { name: t('Checklist.Reason.Incomplete') },
                { name: "OK" },
                { name: "NOK" },
                { name: t('Checklist.Reason.NoNOKResponse') }
              ]}
              optionLabel="name"
              placeholder={t('Common.SelectReasons')}
              className="w-full mt-2 mb-4"
            />

            <div>
            <label
                htmlFor="regularity"
                className="block text-md font-semibold text-gray-800"
            >{t('ServiceTaskDetail.Schedule')}</label>
            <select 
            name='regularity' required
            onChange={(e) => {formik.setFieldValue("regularity",e.target.value);formik.setFieldValue("time_period",[]);}} value={formik.values.regularity}
            className={`bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
              <option value="">{t('Common.SelectOption')}</option>
              <option value="Denne">Denne</option>
              <option value="Týždenne">{t('Common.Weekly')}</option>
              <option value="Mesačne">{t('Common.Monthly')}</option>
            </select>
            </div>
            {formik.values.regularity=="Mesačne" && <div>
            <label
                htmlFor="time_period"
                className="block text-md font-semibold text-gray-800"
            >{t('Common.Frequency')}</label>
            <MultiSelect required value={formik.values.time_period} onChange={(e) => formik.setFieldValue("time_period",e.value)} options={monthTimePeriod} optionLabel="name"
                filter placeholder={t('Common.SelectFrequency')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
            </div>}
            {formik.values.regularity== 'Týždenne' && <div>
            <label
                htmlFor="time_period"
                className="block text-md font-semibold text-gray-800"
            >{t('Common.Frequency')}</label>
            <MultiSelect required value={formik.values.time_period} onChange={(e) => formik.setFieldValue("time_period",e.value)} options={weekTimePeriod} optionLabel="name"
                filter placeholder={t('Common.SelectFrequency')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
            </div>}
            <div>
            <label
                for="email_time"
                className="block text-md font-semibold text-gray-800"
            >{t('Otk.EmailSendTimeUpper')}</label>
            <input
                name='email_time'
                type="time"
                min="05:00" max="22:00"
                required
                onChange={formik.handleChange} value={formik.values.email_time}
                className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
            </div>

            {/* Komu - Oddelenia */}
            <label className="block text-md font-semibold text-gray-800">Komu - Oddelenia</label>
            <MultiSelect
              value={formik.values.recipient_departments}
              onChange={(e) => formik.setFieldValue("recipient_departments", e.value)}
              options={state.departments || []}
              optionLabel="name"
              filter showClear
              placeholder={t('Common.SelectDepartments')}
              className="w-full mt-2 mb-4"
            />

            {/* Komu - Zamestnanci */}
            <label className="block text-md font-semibold text-gray-800">Zamestnanci</label>
            <MultiSelect
              value={formik.values.recipients}
              onChange={(e) => formik.setFieldValue("recipients", e.value)}
              options={
                (formik.values.recipient_departments?.length
                  ? state.users.filter((u) =>
                      u.employee &&
                      formik.values.recipient_departments.some(
                        (dep) => dep.id === u.employee.department_id
                      )
                    )
                  : state.users.filter((u) => u.employee && u.employee?.name)) || []
              }
              filter showClear
              optionLabel="employee.name"
              placeholder={t('Common.SelectUsers')}
              className="w-full mt-2 mb-4"
            />

            {/* Ostatné e-maily */}
            <label className="block text-md font-semibold text-gray-800">{t('Common.OtherEmails')}</label>
            <Chips
              value={formik.values.other_emails}
              onChange={(e) => formik.setFieldValue("other_emails", e.value)}
              onAdd={(e) => emailValidation(e.value)}
              separator=","
              className="block w-full px-4 py-2 mt-2 mb-4 text-grey-700 bg-white border rounded-md"
            />
            {throwInvalidEmail && <Message severity="error" text={t('Common.InvalidEmail')} />}
          </div>
        </div>
      
      <button type="submit" ref={submitRef} className="hidden"></button>
      </div>
    </form>
    </div>
            </>
            );
} 
